import { defineAsyncComponent } from 'vue';

export const shareMicroFrontends = {
	ShareSnapshotGanttModal: defineAsyncComponent(
		() => import('./components/ShareSnapshot/ShareSnapshotGanttModal.vue')
	),
	ShareSnapshotQuoteModal: defineAsyncComponent(
		() => import('./components/ShareSnapshot/ShareSnapshotQuoteModal.vue')
	),
	ShareDocumentPage: defineAsyncComponent(
		() => import('./components/ShareDocument')
	),
};
